import type { IMediumDto, IStyleDto } from '../../model/interface';
import type { IWorkspaceDB } from '../../db/interface';

function mediaForStyling(db: IWorkspaceDB, style: IStyleDto): Promise<Array<IMediumDto>> {
    return new Promise(async function (resolve, reject) {
        try {
            const shouldOpenClose = !db.isOpen();

            if (shouldOpenClose) {
                await db.open();
            }

            const queryIds: Array<string> = [
                style.backgroundImageMediumId,
                style.foregroundImageMediumId,
                style.menuImageMediumId,
            ].filter(mediumId => mediumId && mediumId.length > 1); /* filter falsy values */

            const media = await Promise.all(
                queryIds.map(mediumId => db.get('IMediumDto', mediumId)),
            );

            if (shouldOpenClose) {
                db.close();
            }

            resolve(media);
        } catch (error) {
            reject(error);
        }
    });
}

const module = {
    mediaForStyling,
};

export default module;
